// The two contestants of a stream keep the colours the live board gives them, so
// that a viewer who has been watching the board reads the slides the same way:
// contestant 1 is red, contestant 2 is blue.
const CONTESTANT_COLORS = ['#e56053', '#8181e3'];

// The same colours behind a whole row, faint enough to read white text over
const CONTESTANT_ROW_COLORS = ['rgba(229, 96, 83, 0.22)', 'rgba(129, 129, 227, 0.22)'];

export { CONTESTANT_COLORS, CONTESTANT_ROW_COLORS };
